/* eslint-disable max-len */
import { toast } from 'react-toastify';
const reinviteSuccessToast = () => toast('Your re-invite has been sent successfully.');
const reinviteErrorToast = () => toast('An error has occurred and your re-invite was not sent. Please try again or contact your system administrator if the problem persists.');
const approvalSuccessToast = () => toast('Your connection has been approved.');
const approvalErrorToast = () => toast('An error has occurred and the connection was not approved. Please try again or contact your system administrator if the problem persists.');
const bulkApproveToast = () => toast('The selected users have been approved.');
const bulkReinviteSuccessToast = () => toast('The selected users have been reinvited.');
const securityGroupChangedSuccessToast = () => toast('Security group changed successfully for the selected user.');
const securityGroupChangedFailureToast = () => toast('There was an error changing the security group for the selected user.');
const setInactiveDateSuccessToast = () => toast('Activity status changed successfully for the selected user.');
const setInactiveDateFailureToast = () => toast('There was an error changing the activity status for the selected user.');

export {
  reinviteSuccessToast,
  reinviteErrorToast,
  approvalSuccessToast,
  approvalErrorToast,
  bulkApproveToast,
  bulkReinviteSuccessToast,
  securityGroupChangedSuccessToast,
  securityGroupChangedFailureToast,
  setInactiveDateSuccessToast,
  setInactiveDateFailureToast
}